import { render, staticRenderFns } from "./pgyqDialog.vue?vue&type=template&id=404d4f4a&"
import script from "./pgyqDialog.vue?vue&type=script&lang=js&"
export * from "./pgyqDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports